import React from "react";
import { getLang, setLang, t } from "../i18n";
import { setState } from "../store";
import { GameArt, Link } from "../ui";

const GAMES = ["jackaroo", "ludo", "domino", "carrom", "billiards", "memory"];

export function LangSwitch() {
  const other = getLang() === "ar" ? "en" : "ar";
  return (
    <button className="lang-switch" onClick={() => { setLang(other); setState({}); }}>
      {other === "en" ? "English" : "العربية"}
    </button>
  );
}

export function PublicHeader() {
  return (
    <header className="public-head">
      <Link to="/" className="brand">
        <img src="/brand/samra-symbol.svg" alt="" width="36" height="36" />
        <span>{t.appName}</span>
      </Link>
      <LangSwitch />
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="public-foot">
      <span>{t.footer}</span>
      <nav>
        <Link to="/help">{t.help}</Link>
        <Link to="/privacy">{t.privacy}</Link>
        <Link to="/terms">{t.terms}</Link>
      </nav>
    </footer>
  );
}

export function Landing() {
  return (
    <div className="landing">
      <PublicHeader />
      <section className="landing-hero">
        <div className="landing-copy">
          <h1>{t.tagline}</h1>
          <p>{t.intro}</p>
          <div className="row">
            <Link to="/register" className="btn btn-primary btn-lg">{t.signUp}</Link>
            <Link to="/login" className="btn btn-ghost btn-lg">{t.signIn}</Link>
          </div>
        </div>
        <div className="landing-table" aria-hidden="true">
          {GAMES.map((g, i) => (
            <div key={g} className={`piece piece-${i}`}>
              <GameArt id={g} />
            </div>
          ))}
        </div>
      </section>
      <section className="landing-games">
        {GAMES.map((g) => (
          <Link key={g} to="/register" className="game-tile">
            <GameArt id={g} />
            <strong>{t.game[g]}</strong>
            <span>{t.gameBlurb[g]}</span>
          </Link>
        ))}
      </section>
      <PublicFooter />
    </div>
  );
}
